/* eslint-disable no-underscore-dangle */
const {
  requirejsProps: {
    baseUrl, legacyUrl, queryStringProviderModel,
  },
} = window._webpack_init_props;
delete window._webpack_init_props.requirejsProps;

const fileHashDictionary = queryStringProviderModel.GetFileHashDictionary;
const buildTimeText = queryStringProviderModel.BuildTimeText;
const assemblyVersionText = queryStringProviderModel.AssemblyVersionText;
const versionProvider = {
  getQuery: (filename) => {
    let queryString = '';
    if (filename) {
      const dictionary = fileHashDictionary;
      if (dictionary && dictionary[filename]) {
        queryString = dictionary[filename];
      }
    }

    if (!queryString && buildTimeText) {
      queryString = buildTimeText;
    }

    if (!queryString) {
      queryString = assemblyVersionText;
    }
    return `v=${queryString}`;
  },
};

const init = (require) => {
  require.config({
    baseUrl,
    paths: {
      legacy: legacyUrl,
    },
    urlArgs: (id, url) => {
      const jsMatches = /^(.+)\/(.+).js$/.exec(url);
      const cssMatches = /^(.+)\/(.+).css$/.exec(url);
      let filename = '';
      if (jsMatches && jsMatches.length > 2) {
        filename = `${jsMatches[2]}.js`;
      } else if (cssMatches && cssMatches.length > 2) {
        filename = `${cssMatches[2]}.css`;
      }
      return `?${versionProvider.getQuery(filename)}`;
    },
  });
};

export default init;
